import clsx from 'clsx'
import CodeViewer from 'components/CodeViewer/CodeViewer'
import { formatJSON } from 'helpers/format'
import { ChartNoAxesCombinedIcon } from 'lucide-react'
import { IdEventV4 } from 'models/event'

import { SmartSignalDefinition } from './SmartSignalRepresentation'

export const highActivityDefinition: SmartSignalDefinition<{
  high_activity_device?: IdEventV4['high_activity_device']
}> = {
  key: 'high-activity',
  label: 'High activity',
  extract: (e) => ({ high_activity_device: e.high_activity_device }),
  icon(e) {
    const p = this.extract(e)?.high_activity_device
    return (
      <ChartNoAxesCombinedIcon
        className={clsx('size-4', {
          'text-red-800': p,
        })}
      />
    )
  },
  details(e) {
    return (
      <CodeViewer
        value={formatJSON(this.extract(e))}
        withSearch={false}
        className={this.isDetected(e) ? 'bg-red-100 border-red-300' : 'bg-gray-100'}
      />
    )
  },
  isDetected(e) {
    const p = this.extract(e)?.high_activity_device
    return p === true
  },
  isWeb: () => false,
  isMobile: () => true,
  searchFor: '"high_activity_device":',
  documentationHash: '#high-activity-device',
}
